/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AUTH_CLIENT_ID,//"1b09e18a-7d2b-4953-b08e-68ad97af2823",
        authority: process.env.REACT_APP_AUTH_AUTHORITY, //"https://login.microsoftonline.com/41f88ecb-ca63-404d-97dd-ab0a169fd138",
        redirectUri: process.env.REACT_APP_AUTH_REDIRECTURI //"http://localhost:3000",
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        if (process.env.NODE_ENV !== 'production') {
                            //console.info(message);
                        }
                        return;
                    case LogLevel.Verbose:
                        if (process.env.NODE_ENV !== 'production') {
                            console.debug(message);
                        }
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        //console.log(message);
                        return;
                }
            }
        }
    }
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
export const protectedResources = {
    apiTodoList: {
        endpoint: "http://localhost:5000/api/todolist",
        scopes: {
            read: ["api://Enter_the_Web_Api_Application_Id_Here/Todolist.Read"],
            write: ["api://Enter_the_Web_Api_Application_Id_Here/Todolist.ReadWrite"]
        }
    }
}
 */
export const protectedResources = {
    graphUser: {
        endpoint: 'https://graph.microsoft.com/User.ReadBasic.All',
        scopes: ['User.ReadBasic.All'],
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    //scopes: [...protectedResources.apiTodoList.scopes.read, ...protectedResources.apiTodoList.scopes.write]
    scopes: ["User.Read"]
};